import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { APP_ENV, ENABLED_FEATURES } from 'appenv';
import styled from 'styled-components';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';

import { UserSessionContext } from 'components/UserSession';
import Routes from 'Routes';

import HelpButton from './HelpButton';
import DrawerContainer from './mobile/DrawerContainer';
import SearchButtonContainer from './mobile/SearchButtonContainer';
import BookmarksButton from './BookmarksButton';

const RootContainer = styled.div`
  width: 100%;
`;

const useAppBarStyles = makeStyles(() => ({
  root: {
    zIndex: 1000,
  },
  colorPrimary: {
    color: '#484848',
    backgroundColor: '#FFF',
  },
}));

const StyledToolbar = withStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))(Toolbar);

const StyledLogoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 30%;
  right: 30%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledLink = styled(Link)`
  display: inline-flex;
`;

const LogoImage = styled.img`
  display: inline;
  height: ${['polyu618_staging', 'polyu618_production'].includes(APP_ENV) ? '30' : '56'}px;
  &:not(:last-child) {
    margin-right: 8px;
  }
`;

export default function MobileAppBar({ logos }) {
  const appBarClasses = useAppBarStyles();
  const { canSee, firstVisibleRoute } = useContext(UserSessionContext);

  return (
    <>
      <RootContainer>
        <AppBar
          position="fixed"
          className={`${appBarClasses.root} ${appBarClasses.colorPrimary}`}
          elevation={0}
        >
          <StyledToolbar>
            <DrawerContainer />
            <StyledLogoContainer>
              <StyledLink to={Routes[firstVisibleRoute]}>
                {logos.map((logoUrl, index) => <LogoImage src={logoUrl} alt="Event Logo" key={index} />)}
              </StyledLink>
            </StyledLogoContainer>
            {ENABLED_FEATURES.bookmarks && <BookmarksButton />}
            <HelpButton />
            {
              canSee('search') && <SearchButtonContainer />
            }
          </StyledToolbar>
        </AppBar>
      </RootContainer>
    </>
  );
}

MobileAppBar.propTypes = {
  logos: PropTypes.arrayOf(PropTypes.string).isRequired,
};
